const fr = {
pleaseEnterUsername: "Veuillez saisir un nom d'utilisateur",
cannotFriendYourself: "Vous ne pouvez pas vous envoyer une demande d'ami.",
friendRequestSent: "Demande d'ami envoyée !",
failedToSendRequest: "Échec de l'envoi de la demande",
linkCopied: "Lien copié dans le presse-papiers !",
backToInvites: "Retour aux invitations",
sendFriendRequestByUsername: "Envoyer une demande d'ami par nom d'utilisateur",
enterUsername: "Saisissez un nom d'utilisateur",
send: "Envoyer",
yourInviteQrCode: "Votre QR code d'invitation",
inviteLink: "Lien d'invitation",
scanQrOrUseLink: "Scannez ce QR code ou utilisez ce lien pour envoyer une demande d'ami, beaucoup trop long lol",
copyInviteLink: "Copier le lien d'invitation",
goToItem: "Aller à l'élément",
verificationEmailSent: "E-mail de vérification envoyé ! Consultez votre boîte de réception.",
verificationEmailFailed: "Échec de l'envoi de l'e-mail de vérification. Veuillez réessayer.",
verifyYourEmail: "Vérifiez votre adresse e-mail",
verifyEmailInstructions: "Veuillez vérifier votre adresse e-mail pour accéder à votre compte. Consultez votre boîte de réception pour trouver le lien de vérification.",
sending: "Envoi en cours...",
resendVerificationEmail: "Renvoyer l'e-mail de vérification",
login: "Connexion",
register: "Inscription",
home: "Accueil",
calendar: "Calendrier",
friends: "Amis",
profile: "Profil",
logout: "Déconnexion",
loading: "Chargement...",
language: "Langue",
calendarSelectPlaceSuggestion: "Veuillez sélectionner un lieu dans les suggestions afin d'associer ses coordonnées.",
calendarSelectDateAndTime: "Veuillez sélectionner une date et une heure.",
calendarPositiveDuration: "Veuillez indiquer une durée positive.",
calendarFutureDateRequired: "La date et l'heure de l'événement doivent être dans le futur.",
calendarCreateEventFailed: "Échec de la création de l'événement. Veuillez réessayer.",
cancel: "Annuler",
createNewEvent: "Créer un nouvel événement",
week: "Semaine",
month: "Mois",
eventTitle: "Titre",
date: "Date",
time: "Heure",
duration: "Durée",
endsAt: "Se termine à",
place: "Lieu",
searchForPlace: "Rechercher un lieu",
placeSearchTip: "Conseil : commencez à saisir un lieu, puis sélectionnez un résultat afin d'associer ses coordonnées.",
description: "Description",
createEvent: "Créer l'événement",
today: "Aujourd'hui",
previousMonth: "Mois précédent",
nextMonth: "Mois suivant",
previous: "Préc.",
next: "Suiv.",
mondayShort: "Lun.",
tuesdayShort: "Mar.",
wednesdayShort: "Mer.",
thursdayShort: "Jeu.",
fridayShort: "Ven.",
saturdayShort: "Sam.",
sundayShort: "Dim.",
more: "autres",
mustRespondWillBeforeReposting: "Vous devez répondre « je viendrai » avant de republier",
event: "Événement",
backToCalendar: "Retour au calendrier",
addToGoogleCalendar: "Ajouter à Google Agenda",
when: "Date et heure",
where: "Lieu",
openLocationInGoogleMaps: "Ouvrir le lieu dans Google Maps",
hosts: "Organisateurs",
yourResponse: "Votre réponse",
currentResponse: "Réponse actuelle",
response_will: "Participera",
response_might: "Participera peut-être",
response_wont: "Ne participera pas",
willRunIntoYou: "Je viendrai",
mightDropBy: "Je viendrai peut-être",
wontCome: "Je ne viendrai pas",
repostToMyFriends: "Republier auprès de mes amis",
responses: "Réponses",
willAttend: "Participeront",
reposted: "Republié",
mightAttend: "Participeront peut-être",
cancelEvent: "Annuler l'événement",
cancellationEmailNoticeBefore: "Les personnes ayant indiqué qu'elles viendraient",
cancellationEmailNoticeAfter: "recevront un e-mail les informant de l'annulation.",
optionalCancellationMessage: "Message facultatif aux participants (1 000 caractères maximum)",
confirmCancelEvent: "Confirmer l'annulation",
clear: "Effacer",
confirmCancellation: "Confirmer l'annulation",
confirmCancellationMessage: "Voulez-vous vraiment annuler cet événement ? Les participants confirmés seront informés et l'événement sera supprimé.",
eventCancelledNotified: "Événement annulé. Participants informés :",
attendees: "participants",
failedToCancelEvent: "Échec de l'annulation de l'événement",
back: "Retour",
cancelled: "Annulé",
ok: "OK",
forgotPassword: "Mot de passe oublié",
email: "Adresse e-mail",
passwordResetLinkSent: "Si un compte existe, un lien de réinitialisation a été envoyé.",
passwordResetRequestFailed: "Échec de la demande de réinitialisation du mot de passe.",
sendResetLink: "Envoyer le lien de réinitialisation",
addFriend: "Ajouter un ami",
incomingRequests: "Demandes reçues",
accept: "Accepter",
deny: "Refuser",
myFriends: "Mes amis",
noFriendsYet: "Vous n'avez pas encore d'amis. Commencez à en ajouter !",
seeProfile: "Voir le profil",
noEventsToRespondTo: "Aucun événement en attente de réponse",
allCaughtUp: "Vous êtes à jour — revenez plus tard pour découvrir les nouveaux événements de vos amis.",
events: "Événements",
unknown: "Inconnu",
noDescriptionProvided: "Aucune description fournie.",
will: "Oui",
maybe: "Peut-être",
wont: "Non",
userNotFound: "Utilisateur introuvable",
friendRequestSentSuccessfully: "Demande d'ami envoyée avec succès !",
friendInvitation: "Invitation d'ami",
sendFriendRequest: "Envoyer une demande d'ami",
loginToSendFriendRequest: "Veuillez vous connecter pour envoyer une demande d'ami",
chooseLanguage: "Choisir la langue",
invalidCredentials: "Identifiants incorrects. Veuillez réessayer.",
username: "Nom d'utilisateur",
password: "Mot de passe",
forgotPasswordQuestion: "Mot de passe oublié ?",
dontHaveAccount: "Vous n'avez pas de compte ?",
registerHere: "Inscrivez-vous ici",
invalidProfilePhotoType: "Type de fichier non valide. Importez une image JPEG, PNG, GIF ou WebP.",
invalidFileExtension: "Extension de fichier non valide",
allowedExtensions: "Extensions autorisées",
fileTooLarge: "Fichier trop volumineux",
maximumFileSize: "Taille maximale",
profilePhotoRemoved: "Photo de profil supprimée.",
failedToRemoveProfilePhoto: "Échec de la suppression de la photo de profil",
profileUpdatedSuccessfully: "Profil mis à jour avec succès !",
failedToUpdateProfile: "Échec de la mise à jour du profil",
privateEmailExplanation: "Vous seul pouvez voir votre adresse e-mail afin d'éviter les messages non sollicités en dehors de la plateforme",
yourEmailIsPrivate: "Votre adresse e-mail est privée.",
profilePhoto: "Photo de profil",
removePhoto: "Supprimer la photo",
firstName: "Prénom",
lastName: "Nom",
tellPeopleAboutYourself: "Présentez-vous",
whereToContactMe: "Où me contacter",
contactInfoPlaceholder: "Instagram : monIdentifiant\nDiscord : monDiscord",
save: "Enregistrer",
notSet: "Non renseigné",
editProfile: "Modifier le profil",
imageToCrop: "Image à recadrer",
zoom: "Zoom",
usePhoto: "Utiliser la photo",
name: "Nom",
whereToContact: "Où contacter cette personne",
removeFriendship: "Supprimer l'amitié",
confirmRemoveFriend: "Confirmer la suppression de l'ami",
confirmRemoveFriendBefore: "Voulez-vous vraiment supprimer",
confirmRemoveFriendAfter: "de votre liste d'amis ? Cette personne sera retirée de votre liste.",
friendRemoved: "Ami supprimé.",
failedToRemoveFriend: "Échec de la suppression de l'ami.",
confirmRemove: "Confirmer la suppression",
error: "Erreur",
removed: "Supprimé",
passwordsDoNotMatch: "Les mots de passe ne correspondent pas",
registrationFailed: "Échec de l'inscription. Veuillez réessayer.",
confirmPassword: "Confirmer le mot de passe",
alreadyHaveAccount: "Vous avez déjà un compte ?",
loginHere: "Connectez-vous ici",
passwordResetSuccessfully: "Mot de passe réinitialisé avec succès.",
failedToResetPassword: "Échec de la réinitialisation du mot de passe.",
resetPassword: "Réinitialiser le mot de passe",
newPassword: "Nouveau mot de passe",
confirmNewPassword: "Confirmer le nouveau mot de passe",
setNewPassword: "Définir le nouveau mot de passe",
emailVerifiedSuccessfully: "Adresse e-mail vérifiée avec succès !",
emailVerificationFailed: "Échec de la vérification. Le lien est peut-être invalide ou expiré.",
verifying: "Vérification en cours...",
verified: "Adresse vérifiée !",
redirectingToHome: "Redirection vers l'accueil...",
verificationFailed: "Échec de la vérification",
goToHome: "Aller à l'accueil",
  about: "À propos",
  aboutConceptTitle: "Concept",
  aboutCreatorIntroduction: "Salut, je suis Crypt0, grimpeur et créateur de Run Into Me.",
  aboutCreatorStory: "J'ai créé ce site parce que je suis très sociable et que, entre deux voies d'escalade, je ne peux pas m'empêcher de parler aux autres grimpeurs. Je me suis ainsi retrouvé avec un peu trop de numéros de grimpeurs dans mes contacts et à consacrer trop de temps libre à organiser des séances d'escalade avec mes nouveaux amis, comme un agent hollywoodien débordé.",
  aboutPlanningProblem: "J'en ai eu assez de devoir planifier ces séances et envoyer un message à chaque ami. Je voulais pouvoir leur indiquer simultanément quand et où j'allais grimper, sans les inviter formellement, afin qu'ils puissent simplement passer s'ils en avaient envie.",
  aboutDeveloperSolution: "C'est alors que je me suis rappelé que j'étais développeur et que je pouvais créer moi-même une solution.",
  aboutWelcome: "Bienvenue sur Run Into Me, un site qui permet à vos amis de savoir quand vous pratiquez une activité à laquelle ils peuvent se joindre, sans pression.",
  aboutCallToAction: "La prochaine fois que vous prévoyez une activité que vous pouvez faire seul, mais qui serait plus amusante à plusieurs (cinéma, course, escalade... les impôts ???), publiez-la ici pour que vos amis la voient !",
  aboutTutorialTitle: "Tutoriel",
  aboutCalendarCreateEvent: "L'écran Calendrier permet également de créer un nouvel événement.",
  aboutEventColorsIntroduction: "Les couleurs des événements indiquent votre statut de participation :",
  aboutColorGold: "Doré",
  aboutColorGoldDescription: "Vous organisez cet événement.",
  aboutColorGreen: "Vert",
  aboutColorGreenDescription: "Vous participez à cet événement.",
  aboutColorOrange: "Orange",
  aboutColorOrangeDescription: "Vous avez répondu « peut-être ».",
  aboutColorBlue: "Bleu",
  aboutColorBlueDescription: "Vous n'avez pas encore répondu.",
  aboutColorGray: "Gris",
  aboutColorGrayDescription: "Vous avez refusé l'invitation.",
  aboutCalendarEventDetails: "Cliquez sur un événement pour obtenir plus d’informations et y répondre.",
  aboutFriendPageTitle: "Page Amis",
  aboutFriendPageDescription: "Pour ajouter un ami, saisissez son nom d'utilisateur ou transmettez-lui votre lien d'invitation / code QR.",
  aboutHomePageTitle: "Page d'accueil",
  aboutHomePageDescription: "Parcourez les événements à venir de vos amis sur l'écran d'accueil pour leur indiquer si vous venez.",
  aboutRepostScreenTitle: "Écran de republication",
  aboutGoogleCalendarDescription: "Pour ne pas manquer un événement, utilisez ce bouton afin de l’ajouter à votre agenda Google.",
  aboutRepostDescription: "Une fois que vous avez indiqué que vous participerez à l'événement d'un ami, vous pouvez le republier auprès de vos amis. L'invitation apparaîtra alors dans l'agenda de vos amis qui ne figurent pas dans la liste d'amis de l'organisateur.",
};

export default fr;